import * as React from 'react';
import { AddToCart } from '@grandvisionhq/carts-v2';
import { Button } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import { useSolutionsEcommContext } from '../../context/SolutionsEcommContext.js';
import { mapSolutionToDraftLineItem } from '../../utils/map-solution-to-draft-line-item.js';
import { SolutionsCTACaption } from './SolutionsCTACaption.js';

const CTAButton = ({ isOrderable , activeSku , addToCartCallback  })=>{
    const { getLabel  } = useIntl();
    const { routes  } = useProductDetailContext();
    const { state , actions  } = useSolutionsEcommContext();
    const lineItemDraft = React.useMemo(()=>{
        return mapSolutionToDraftLineItem({
            sku: activeSku,
            state
        });
    }, [
        state,
        activeSku
    ]);
    if (!isOrderable) {
        return /*#__PURE__*/ React.createElement(Button, {
            caption: getLabel('products.actions.excludedFromCheckout'),
            href: routes.stores
        });
    }
    if (!state.configurator.isConfiguratorValid || !lineItemDraft) {
        // Dummy button with the "Add to cart" caption which only triggers form validations
        return /*#__PURE__*/ React.createElement(Button, {
            caption: getLabel('products.solutions.addToBasket'),
            onClick: ()=>{
                actions.triggerValidationErrors();
            }
        });
    }
    return /*#__PURE__*/ React.createElement(AddToCart, {
        caption: /*#__PURE__*/ React.createElement(SolutionsCTACaption, {
            selectedQuantity: state.configurations.quantity
        }),
        onSuccess: addToCartCallback,
        lineItemDrafts: [
            lineItemDraft
        ]
    });
};

export { CTAButton, CTAButton as default };
//# sourceMappingURL=CTAButton.js.map
